module.exports = __webpack_public_path__ + "static/img/yagi_03.ba37551.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yagi_03.jpg
// module id = 4B4B
// module chunks = 0